import { useTranslation } from 'next-i18next';
import Link from '@components/Link';
import Button from '@components/Button';
import { useSelector } from 'react-redux';

const ConsentCheckbox = ({ className }) => {
  const { t } = useTranslation(['account', 'common', 'checkout']);
  const { isSingle } = useSelector((state) => state.checkout);

  return (
    <div className={className}>
      {t('iAccWashWorld', { ns: 'checkout' })}{' '}
      <Button
        size="extra-small"
        element={Link}
        appearance="text"
        href={`/${t('personalDataPolicyLink', {
          ns: 'common',
        })}`}
        target="_blank"
      >
        {t('privacyPolicy', { ns: 'checkout' })}
      </Button>{' '}
      {t('and', { ns: 'common' })}{' '}
      <Button
        size="extra-small"
        element={Link}
        appearance="text"
        href={`/${t('termsOfTradeLink', {
          ns: 'common',
        })}`}
        target="_blank"
      >
        {t('termOfTrade', { ns: 'checkout' })}
      </Button>
      {'. '}
      {!isSingle
        ? t('membershipAgreement', { ns: 'checkout' })
        : t('membershipAgreementSingle', { ns: 'checkout' })}
    </div>
  );
};

export default ConsentCheckbox;
